import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import logo from '../images/logo.png';
import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [storyDropdown, setStoryDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleNav = () => {
    setNav(!nav);
  };

  const closeNav = () => {
    setNav(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setStoryDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className='fixed w-full top-0 left-0 bg-primary-bg dark:bg-dark-bg z-50 md:z-[100] h-24 border-b border-primary-accent/20 dark:border-dark-accent/20 transition-colors'>
      <div className='flex justify-between items-center max-w-[1240px] mx-auto px-4 pt-3 text-primary-text dark:text-dark-text'>
        <img src={logo} alt="Logo" className='w-10 dark:filter dark:invert' />
        <ul className='hidden md:flex items-center text-lg'>
          <li className='p-4'><Link to="/about">Bemutatkozás</Link></li>
          <li className='p-4 relative' ref={dropdownRef}>
            <button
              onClick={() => setStoryDropdown(!storyDropdown)}
              className='flex items-center gap-1 hover:text-primary-accent2 dark:hover:text-dark-accent2'
            >
              Történet
              <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 transition-transform ${storyDropdown ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {storyDropdown && (
              <ul className='absolute top-full left-0 mt-2 bg-primary-bg dark:bg-dark-bg border border-primary-accent/20 dark:border-dark-accent/20 rounded-lg shadow-lg py-2 min-w-[180px]'>
                <li>
                  <Link
                    to="/story/first-year"
                    onClick={() => setStoryDropdown(false)}
                    className='block px-4 py-2 hover:bg-primary-accent/10 dark:hover:bg-dark-accent/10'
                  >
                    Az első csata
                  </Link>
                </li>
                <li>
                  <Link
                    to="/story/second-year"
                    onClick={() => setStoryDropdown(false)}
                    className='block px-4 py-2 hover:bg-primary-accent/10 dark:hover:bg-dark-accent/10'
                  >
                    Kötéltánc
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li className='p-4'><Link to="/help">Segíteni akarok</Link></li>
          <li className='p-2'><ThemeToggle /></li>
        </ul>
        <div className='flex items-center gap-2 md:hidden'>
          <ThemeToggle />
          <div onClick={handleNav}>
            {nav ? <AiOutlineClose size={20}/> : <AiOutlineMenu size={20} />}
          </div>
        </div>
      </div>
      <div onClick={closeNav} className={nav ? 'fixed inset-0' : 'hidden'}></div>
      <ul className={nav ? 'fixed left-0 top-0 w-[60%] h-full border-r border-primary-accent/20 dark:border-dark-accent/20 bg-primary-bg dark:bg-dark-bg ease-in-out duration-500 z-[110]' : 'ease-in-out duration-500 fixed left-[-100%]'}>
        <img src={logo} alt="Logo" className='w-10 dark:filter dark:invert m-4' />
        <li className='p-4 text-lg border-b border-primary-accent/10 dark:border-dark-accent/10'><Link to="/about" onClick={closeNav}>Bemutatkozás</Link></li>
        <li className='p-4 text-lg border-b border-primary-accent/10 dark:border-dark-accent/10'><Link to="/story/first-year" onClick={closeNav}>Az első csata</Link></li>
        <li className='p-4 text-lg border-b border-primary-accent/10 dark:border-dark-accent/10'><Link to="/story/second-year" onClick={closeNav}>Kötéltánc</Link></li>
        <li className='p-4 text-lg'><Link to="/help" onClick={closeNav}>Segíteni akarok</Link></li>
      </ul>
    </div>
  );
};

export default Navbar;